
import { Component, Vue } from 'vue-property-decorator';
import SearchParameters from '~/components/Logs/SearchParameters.vue';
import LogList from '~/components/Logs/LogList.vue';


@Component({
    components: {
        SearchParameters,
        LogList,
    },
})
export default class Logs extends Vue {
}
